/* 🤖 this file was generated by svg-to-ts */
export const IconBigMediumWinkelLinks: {
    name: 'big-medium-winkel-links';
    data: string;
} = {
    name: 'big-medium-winkel-links',
    data: `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 128 128"><path d="M92 125a5 5 0 0 1-3.53-1.46L35.29 70.36a9 9 0 0 1 0-12.72L88.47 4.46a5 5 0 0 1 7.07 7.08L43.07 64l52.47 52.46A5 5 0 0 1 92 125"/></svg>`,
};
